// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Uyzn","type":"styles_type__2IZRc","choices":"styles_choices__2odhC"};